import React from 'react';
import CustomInput from '../../../../../../components/CustomInput';
import CustomSelect from '../../../../../../components/CustomSelect';

export default function SmsTypeDriverInputs({
    data,
    flag,
    onChange,
    onSelectChange,
    selectOptions,
}) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomSelect
                    labelText="Driver"
                    name={`sms_driver_id_${flag}`}
                    onChange={(value) => onSelectChange(value, flag)}
                    value={data[flag]?.sms_driver_id}
                    options={selectOptions}
                />
            </div>
            {!data[flag]?.sms_driver_id && (
                <>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`sms_driver_name_${flag}`}
                            placeholder="Enter name"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.sms_driver_name}
                            labelText="Name"
                            width="100%"
                            //   errorText={errors?.name}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`sms_driver_username_${flag}`}
                            placeholder="Enter username"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.sms_driver_username}
                            labelText="Username"
                            width="100%"
                            //   errorText={errors?.client_id}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`sms_driver_password_${flag}`}
                            placeholder="Enter password"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.sms_driver_password}
                            labelText="Password"
                            width="100%"
                            //   errorText={errors?.client_id}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`sms_driver_service_url_${flag}`}
                            placeholder="Enter service URL"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.sms_driver_service_url}
                            labelText="Service URL"
                            width="100%"
                            //   errorText={errors?.client_id}
                        />
                    </div>
                </>
            )}
        </>
    );
}
